import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentUserData, EstablishmentUserResponse } from "@/common/types/establishmentUsers.type"

import { UseQueryResult, useQuery } from "@tanstack/react-query"

type UseEstablishmentUserProps = {
  id: string
}

type UseEstablishmentUserType = ({}: UseEstablishmentUserProps) => UseQueryResult<EstablishmentUserData, unknown>

export const useEstablishmentUser: UseEstablishmentUserType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentUserResponse, unknown, EstablishmentUserData>({
    queryKey: ['establishmentUser', id],
    queryFn: () => {
      return privateAxios.get(`/establishment/users/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
